import { createSlice } from '@reduxjs/toolkit';
import {
  addMediaToAssetFolderBuilder,
  createAssetFoldersBuilder,
  deleteAssetFolderBuilder,
  editAssetFolderBuilder,
  fetchAssetFolderByIdBuilder,
  fetchAssetFoldersBuilder,
  removeMediaFromAssetFolderBuilder,
} from './builder';
import { LOGOUT } from '../../../utils/constants';

const INIT_STATE = {
  fetchAssetFoldersInfo: {
    pending: false,
    data: [],
  },
  pending: {
    createAssetFolders: false,
    fetchAssetFolderById: false,
    deleteAssetFolder: false,
    editAssetFolder: false,
    addMediaToAssetFolder: false,
    removeMediaFromAssetFolder: false,
  },
};

export const assetFolderSlice = createSlice({
  name: 'assetFolder',
  initialState: INIT_STATE,
  reducers: {},
  extraReducers: builder => {
    fetchAssetFoldersBuilder(builder);
    createAssetFoldersBuilder(builder);
    fetchAssetFolderByIdBuilder(builder);
    deleteAssetFolderBuilder(builder);
    editAssetFolderBuilder(builder);
    addMediaToAssetFolderBuilder(builder);
    removeMediaFromAssetFolderBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const selectFetchAssetFoldersInfo = state => state.assetFolderInfo.fetchAssetFoldersInfo;
export const selectAssetFolderActionsPending = state => state.assetFolderInfo.pending;

export default assetFolderSlice.reducer;
